module.exports = __webpack_public_path__ + "img/i-lingerie.5c5a0618.svg";